module.exports = __webpack_public_path__ + "img/88.70c4b811.png";